export default __webpack_public_path__ + "static/media/bg-single.8a06ade2.jpg";